import isEmpty from 'lodash.isempty';
import { useQueryClient } from '../../lib';
import { getAuthTokenKey } from '../../utils/keys';
export const useCachedAuthToken = () => {
    const queryClient = useQueryClient();
    const queries = queryClient.getQueriesData({
        queryKey: getAuthTokenKey(),
    });
    let authToken;
    queries === null || queries === void 0 ? void 0 : queries.forEach(query => {
        const data = query === null || query === void 0 ? void 0 : query[1];
        if (data) {
            authToken = {
                ...authToken,
                ...data,
            };
        }
    });
    if (!isEmpty(authToken))
        return authToken;
};
//# sourceMappingURL=useCachedAuthToken.js.map